/**
 * @file sideDomain.ts
 * @author Rapoo Device SDK Team
 * @date 2026-06-22
 * @description CH585M 侧灯灯效领域描述
 */

import {
  LightingDomainDescriptor,
  LightingDomainType,
  LightingFeatureFlag,
} from '../../../../../types/lightingDomain'
import { getAddress } from '../../../../../utils/common'
import { ADDRESS_CH585M } from '../../../protocols/address'
import { genrateSideLightEffectAddressLevel } from '../../../protocols/addressGenerators'
import { sanitizeLightingLevel } from '../../../../shared/feature-impls/keyboard-lighting/lighting'

export const sideDomain: LightingDomainDescriptor = {
  type: LightingDomainType.Side,
  configSize: 8,
  supportedFeatures:
    LightingFeatureFlag.Brightness |
    LightingFeatureFlag.Speed |
    LightingFeatureFlag.SingleColor |
    LightingFeatureFlag.Colorful,

  addressResolver: {
    getBaseAddr: (configIndex, itemIndex) => {
      return getAddress(ADDRESS_CH585M.SIDE_DYNAMIC_LIGHT_BRIGHTNESS, configIndex, itemIndex)
    },
    getFieldAddr: (field, configIndex, itemIndex) => {
      const fieldOffsetMap: Record<string, number> = {
        brightness: 0,
        speed: 1,
        isColorful: 2,
      }
      const offset = fieldOffsetMap[field] ?? 0
      return getAddress(genrateSideLightEffectAddressLevel(offset), configIndex, itemIndex)
    },
  },

  parser: {
    parse: (buffer, index) => ({
      index,
      domainType: LightingDomainType.Side,
      brightness: sanitizeLightingLevel(buffer[0]),
      speed: sanitizeLightingLevel(buffer[1]),
      isColorful: buffer[2] === 0,
      rgb: { r: buffer[4], g: buffer[5], b: buffer[6] },
      buffer,
    }),
    serialize: (config) => {
      const buf = new Uint8Array(8)
      buf[0] = sanitizeLightingLevel(config.brightness)
      buf[1] = sanitizeLightingLevel(config.speed)
      buf[2] = config.isColorful ? 0 : 1
      buf[3] = 0
      buf[4] = config.rgb?.r ?? 255
      buf[5] = config.rgb?.g ?? 255
      buf[6] = config.rgb?.b ?? 255
      buf[7] = 0
      return buf
    },
  },

  cacheTags: (index, configIndex) => [`light:side:${index}`, `cfg:${configIndex}`],
}
